// Geo-redirect: send non-EU/EEA visitors from en.originguide.org → en-us.originguide.org.
// Relies on Cloudflare's `cdn-cgi/trace` endpoint for country detection.

(function () {
    if (sessionStorage.getItem('og_geo_checked')) return;

    const ua = navigator.userAgent || '';
    if (/bot|crawl|spider|slurp|bingpreview|googlebot/i.test(ua)) return;

    const override = document.cookie.split('; ').find((c) => c.startsWith('market_override='));
    if (override && override.split('=')[1] === 'eu') return;

    const EU_EEA_UK = new Set([
        'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI',
        'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT',
        'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'IS', 'LI', 'NO',
        'CH', 'GB',
    ]);

    fetch('/cdn-cgi/trace', { cache: 'no-store' })
        .then((r) => (r.ok ? r.text() : ''))
        .then((text) => {
            sessionStorage.setItem('og_geo_checked', '1');
            const match = text.match(/^loc=([A-Z]{2})$/m);
            if (!match) return;
            const country = match[1];
            if (!country || EU_EEA_UK.has(country)) return;
            window.location.replace('https://en-us.originguide.org' + window.location.pathname + window.location.search);
        })
        .catch(() => {});
})();
